module.exports = __webpack_public_path__ + "static/media/carnaval.3b7d405c.jpg";